exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._eprom-status{width:100%}._eprom-status .divider--inset{margin-left:0!important;width:100%!important}._eprom-status .error-status{font-size:18px;color:#dc2814}._eprom-status .error-status .status-label{color:#4d4d4d}._eprom-status .error-status .error-row-eprom{border-bottom:1px solid #ccc;margin:10px 0}._eprom-status .error-status .error-row-eprom .eprom-status-message{font-size:14px;color:#7d7d7d}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/stylus-loader!./src/components/plain/epromStatus/epromStatus.styl
// module id = 441
// module chunks = 0